import React, { useState } from "react";
import Select from 'react-select'
import {
    format
} from "date-fns";

const createPackageSource = (baseUrl) => {
    
    return {
        getDepartures: async () => {
            const response = await fetch(`${baseUrl}/api/packages`);
            const result = await response.json();
            return result;
        },
        getDestinations: async (departureAirports) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/packages/${dep}`);
            const result = await response.json();
            return result;
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/packages/${dep}/search?query=${text}`);
            const result = await response.json();
            return result;
        },
        getAvailableDates: async (departureAirports, destination) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/packages/${dep}/${destination}`);
            const result = await response.json();
            return result;
        },
        getReturnDates: async (departureAirports, destination, date) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/packages/${dep}/${destination}/${format(date, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate) => {
            if(destination === undefined){
                destination = "null";
            }
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/packages/validate/${dep}/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        }
    }
}

const getDataSource = (source, baseUrl) => {
    if (source == "packages") {
        return createPackageSource(baseUrl);
    }
}

export default { getDataSource };